import React, { useContext } from "react";
import { HomepageContext } from "@/components/header/ConnectedHeader";
import { generateProductAnchorId } from "@/utils";
import {
  SectionTitle,
  RichTextContent,
  PropertiesBox,
  ImageWithSrcSet,
  SectionContainer,
  AnimatedInView,
} from "@/components";
import styles from "./SolarSection.module.css";

export const SolarSection: React.FC = () => {
  const { data } = useContext(HomepageContext);

  if (!data) return null;

  const { solar_section, products_section } = data;
  const anchorId = generateProductAnchorId(
    products_section.grid_solar.grid_solar_link,
    products_section.products_section_title_h2
  );

  return (
    <SectionContainer id={anchorId} className={styles.section}>
      <SectionTitle title={solar_section.solar_section_title_h2} />
      <div className={styles.content}>
        <AnimatedInView className={styles.imageWrapper}>
          <ImageWithSrcSet
            image={solar_section.solar_section_img}
            alt={solar_section.solar_section_img_alt}
            className={styles.image}
          />
        </AnimatedInView>
        <div className={styles.textContent}>
          <RichTextContent
            content={solar_section.solar_section_desc}
            className={styles.description}
          />
          <PropertiesBox content={solar_section.solar_section_props} />
        </div>
      </div>
    </SectionContainer>
  );
};
